import { ReactElement } from 'react';
import { openLinkInNewTab } from '../../util';

interface DiscordBtnProps {
  children?: ReactElement[];
}

const discord = openLinkInNewTab('https://discord.gg/d75N3ZPZSp');

const DiscordBtn: React.FC<DiscordBtnProps> = ({ children }) => {
  return (
    <a href="/" onClick={discord}>
      <button>Join the biiird games Discord</button>
    </a>
  );
};

export default DiscordBtn;
export { discord };
